module.exports = __webpack_public_path__ + "img/feedback-btn.2228b0bd.svg";